import { useTranslation } from 'react-i18next';
import HotelPickerPage from '../Allotments/Partials/HotelPickerPage';
import NightRatesHotelEditor from './Partials/NightRatesHotelEditor';

export default function NightRates() {
  const { t } = useTranslation();

  return (
    <HotelPickerPage title={t('pages:nightRates')} kind="nightRates">
      {({ hotel, hotelData }) => (
        <NightRatesHotelEditor
          hotel={hotel}
          currency={hotelData?.currency?.toUpperCase()}
          canUpdateHotel={hotelData?.canUpdateHotel ?? false}
        />
      )}
    </HotelPickerPage>
  );
}
